import { TableColumn } from '../../models';
import { IconCellComponent, IconCellProps } from './icon.component';

export class IconColumn<I> extends TableColumn<I, IconCellProps> {
  readonly component = IconCellComponent;
}
